import React, { Component } from 'react';
import { View, Image, StyleSheet, Dimensions, Animated, InteractionManager } from 'react-native';

import { OPPureComponent } from '../components';

import SoundPlayer from '../../SoundPlayer';

const F16_TEXT = '((Sent an F16))';
const MQ9_TEXT = '((Sent an MQ9))';

const AIRFORCE_ANIMATING_IMAGES = {
  F16_1: require('../../../resources/f16-flight.png'),
  F16_2: require('../../../resources/f16-flight-left.png'),
  MQ9_1: require('../../../resources/mq9-flight.png'),
};

const ANIMATIONS_COMPLETE = [];

const IMAGE_WIDTH = 50;
const NUM_IMAGES = 15;
const ANIMATION_DURATION = 1500;
const TIMING_INTERVAL = 150;

const F16_WIDTH = 368;
const F16_HEIGHT = 61;
const NUM_IMAGES_F16 = 8;
const ANIMATION_DURATION_F16 = 1500;
const TIMING_INTERVAL_F16 = 350;

const MQ9_WIDTH = 132;
const MQ9_HEIGHT = 335;
const NUM_IMAGES_MQ9 = 7;
const ANIMATION_DURATION_MQ9 = 1500;
const TIMING_INTERVAL_MQ9 = 350;

export default class GiftDisplay extends OPPureComponent {
  constructor(props) {
    super(props);

    this.state = {
      animating: false,
      variant: null,
    };

    this._finishedAnimations = 0;
  }

  playMessage(message, force) {
    console.info('>>>> playMessage');
    let variant = null;
    let imageSrc1 = this.props.giftMessages[message.text];
    let imageSrc2 = null;
    if (message.text === F16_TEXT) {
      variant = 'f16';
      imageSrc1 = AIRFORCE_ANIMATING_IMAGES['F16_1'];
      imageSrc2 = AIRFORCE_ANIMATING_IMAGES['F16_2'];
    } else if (message.text === MQ9_TEXT) {
      variant = 'mq9';
      imageSrc1 = AIRFORCE_ANIMATING_IMAGES['MQ9_1'];
    }

    InteractionManager.runAfterInteractions(() => {
      if (force || ANIMATIONS_COMPLETE.indexOf(message._id) < 0) {
        ANIMATIONS_COMPLETE.push(message._id);
        this.startAnimating(imageSrc1, imageSrc2, {
          variant,
        });
      }
    });
  }

  startAnimating(imageSource1, imageSource2, { variant }) {
    this._imageSource = imageSource1;
    this._imageSource2 = imageSource2;
    this._finishedAnimations = 0;
    this.setState({ animating: true, variant: variant || null });
  }

  _go = variant => {
    let numImages = NUM_IMAGES;
    if (variant === 'f16') numImages = NUM_IMAGES_F16;
    else if (variant === 'mq9') numImages = NUM_IMAGES_MQ9;

    let timingInt = TIMING_INTERVAL;
    if (variant === 'f16') timingInt = TIMING_INTERVAL_F16;
    else if (variant === 'mq9') timingInt = TIMING_INTERVAL_MQ9;

    if (variant === 'f16') SoundPlayer.playSoundFile('f16', 'mp3');
    else if (variant === 'mq9') SoundPlayer.playSoundFile('mq9', 'mp3');

    for (let i = 0; i < numImages; i++) {
      setTimeout(() => {
        if (variant === 'f16') {
          this._animateF16GiftView(i);
        } else if (variant === 'mq9') {
          this._animateMQ9GiftView(i);
        } else {
          this._animateGiftView(i);
        }
      }, 100 + timingInt * i);
    }
  };

  _finishedAnimating = (i, numImages) => {
    if (++this._finishedAnimations != numImages) return;

    this._finishedAnimations = 0;
    this._imageSource = null;
    this._imageSource2 = null;

    SoundPlayer.stop();

    this.setState({ animating: false, variant: null });
  };

  _animateGiftView = i => {
    this.state[`image${i}_opacity`].setValue(1);

    Animated.timing(this.state[`image${i}_opacity`], {
      toValue: 0,
      duration: ANIMATION_DURATION,
      useNativeDriver: false,
    }).start(() => {
      this._finishedAnimating(i, NUM_IMAGES);
    });
  };

  _animateF16GiftView = i => {
    const coords = this._coords[i];
    if (!coords) return;

    const toValue = coords.left < 0 ? this._width : 0 - F16_WIDTH;
    Animated.timing(this.state[`image${i}_left`], {
      toValue,
      duration: ANIMATION_DURATION_F16,
      useNativeDriver: false,
    }).start(() => {
      this._finishedAnimating(i, NUM_IMAGES_F16);
    });
  };

  _animateMQ9GiftView = i => {
    const coords = this._coords[i];

    const toValue = 0 - MQ9_WIDTH;
    Animated.timing(this.state[`image${i}_top`], {
      toValue,
      duration: ANIMATION_DURATION_MQ9,
      useNativeDriver: false,
    }).start(() => {
      this._finishedAnimating(i, NUM_IMAGES_MQ9);
    });
  };

  _renderAnimatingGiftF16 = (coord, i) => {
    if (!coord) return;
    let { top, left } = coord;

    let coordsStyle = null;
    let imageSource = this._imageSource;
    if (coord.left > 0) imageSource = this._imageSource2;
    this.state[`image${i}_left`] = new Animated.Value(left);
    coordsStyle = {
      left: this.state[`image${i}_left`],
      top,
    };
    return (
      <Animated.Image
        key={`${top}_${left}_${i}`}
        style={[styles.animatingGiftF16, coordsStyle]}
        source={imageSource}
        resizeMode="contain"
      />
    );
  };

  _renderAnimatingGiftMQ9 = (coord, i) => {
    let { top, left } = coord;

    let coordsStyle = null;
    let imageSource = this._imageSource;
    this.state[`image${i}_top`] = new Animated.Value(top);
    coordsStyle = {
      left,
      top: this.state[`image${i}_top`],
    };
    return (
      <Animated.Image
        key={`${top}_${left}_${i}`}
        style={[styles.animatingGiftMQ9, coordsStyle]}
        source={imageSource}
        resizeMode="contain"
      />
    );
  };

  _renderAnimatingGift = (coord, i, variant) => {
    if (variant === 'f16') {
      return this._renderAnimatingGiftF16(coord, i);
    } else if (variant === 'mq9') {
      return this._renderAnimatingGiftMQ9(coord, i);
    }

    let { top, left } = coord;
    this.state[`image${i}_opacity`] = new Animated.Value(0);
    let opacityStyle = {
      opacity: this.state[`image${i}_opacity`],
    };
    let imageSource = this._imageSource;
    return (
      <Animated.Image
        key={`${top}_${left}_${i}`}
        style={[styles.animatingGift, { top, left }, opacityStyle]}
        source={imageSource}
        resizeMode="contain"
      />
    );
  };

  setupCoordsStandard(height, width) {
    let coords = [];
    while (coords.length < NUM_IMAGES) {
      let top = parseInt(Math.random() * (height - 80 - IMAGE_WIDTH));
      let left = parseInt(Math.random() * (width - IMAGE_WIDTH));

      coords.push({ top, left });
    }
    return coords;
  }

  setupCoordsF16(height, width) {
    let coords = [];
    while (coords.length < NUM_IMAGES_F16) {
      let top = parseInt(Math.random() * (height - 180 - F16_HEIGHT));
      let horiz = Math.random();
      if (horiz < 0.5) left = 0 - F16_WIDTH;
      else left = width;

      coords.push({ top, left });
    }
    return coords;
  }

  setupCoordsMQ9(height, width) {
    let coords = [];
    while (coords.length < NUM_IMAGES_MQ9) {
      let left = parseInt(Math.random() * (width - MQ9_WIDTH));
      let top = height + MQ9_WIDTH;

      coords.push({ top, left });
    }
    return coords;
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.animating && !prevState.animating) {
      this._go(this.state.variant);
    }
  }

  render() {
    if (!this.state.animating) {
      return <View style={styles.container} />;
    }

    let { height, width } = Dimensions.get('window');
    this._height = height;
    this._width = width;

    const variant = this.state.variant;

    let coords;
    if (variant === 'f16') {
      coords = this.setupCoordsF16(height, width);
    } else if (variant === 'mq9') {
      coords = this.setupCoordsMQ9(height, width);
    } else {
      coords = this.setupCoordsStandard(height, width);
    }
    this._coords = coords;

    return (
      <View pointerEvents="none" style={[styles.container, { width, height }]}>
        {coords.map((coord, i) => this._renderAnimatingGift(coord, i, variant))}
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    top: 0,
    left: 0,
    height: 0,
  },
  animatingGift: {
    position: 'absolute',
    width: IMAGE_WIDTH,
    height: IMAGE_WIDTH,
  },
  animatingGiftF16: {
    position: 'absolute',
    width: F16_WIDTH,
    height: F16_HEIGHT,
  },
  animatingGiftMQ9: {
    position: 'absolute',
    width: MQ9_WIDTH,
    height: MQ9_HEIGHT,
  },
});
